import { makeFloat } from 'react-easyrocket';
import { ValidateTransactionValue } from '../components/Deposit/types';
import { t } from 'i18next';
import { getMinDepositOfBonus } from './getMinDepositOfBonus';

export const validateMaxLength = (maxLength: number) => (value: string) => {
  if (value && value.length > maxLength)
    return `${t('general.valueLonger')} ${maxLength} ${t('general.characters')}`;
  return undefined;
};

export function validateTransactionValue({
  globalMin,
  globalMax,
  currencyIcon,
  currencyName,
  selectedPaymentMethod,
  makeFloatFixedValue = 2,
  selectedBonus,
  hasBonusAmountError
}: ValidateTransactionValue) {
  const shouldValidateBonusMinAmount = currencyName && selectedBonus;

  return (value: string) => {
    // введенное пользователем значение
    const amountValue = parseFloat(value);
    hasBonusAmountError.current = false;

    // selectedPaymentMethod.min_amount и selectedPaymentMethod.max_amount приходят как
    // дробные числа и не нуждаются в применении makeFloat. globalMin и globalMax приходят как
    // как целые числа и НУЖДАЮТСЯ в применении makeFloat.
    const min = Math.max(Number(selectedPaymentMethod?.min_amount || 0), +makeFloat(globalMin));
    // Если один из максимальных лимитов оказывается нулем - то это означает что максимального ограничения
    // по сумме ввода нет. Поэтому для того чтобы Math.min выбрал лимит корректно все нули подменяются на
    // бесконечность
    const max = Math.min(
      Number(selectedPaymentMethod?.max_amount || 0) || Infinity,
      +makeFloat(globalMax) || Infinity
    );

    if (amountValue < min || !amountValue) {
      return `${t('depositTab.lessThanMinimumAmountError', { amount: `${currencyIcon}${min.toFixed(makeFloatFixedValue)}` })} `;
    }
    if (max !== undefined && max > 0 && amountValue > max) {
      return `${t('depositTab.moreThenMaximumAmountError', { amount: `${currencyIcon}${max.toFixed(makeFloatFixedValue)}` })} `;
    }

    if (!shouldValidateBonusMinAmount) return undefined;

    const selectedBonusMinAmount = getMinDepositOfBonus({
      bonus: selectedBonus,
      currency: currencyName
    });

    const hasPromoCodeError = selectedBonusMinAmount > Number(value);

    if (hasPromoCodeError) {
      hasBonusAmountError.current = true;
      return `${t('depositTab.lessThanMinimumAmountBonusError', { amount: `${currencyIcon}${selectedBonusMinAmount.toFixed(makeFloatFixedValue)}` })} `;
    }

    return undefined;
  };
}
